/* eslint-disable @typescript-eslint/naming-convention */
import { useQuery, useReactiveVar } from '@apollo/client';
import { useState } from 'react';
import { GET_SONG } from '../../graphql/queries/song/song';
import {
  appendTokenToSongAssets,
  dismissLoadingMessage,
  displayErrorMessage,
} from '../../utils/helpers';
import { organisationLoggedInAs } from '../../utils/reactiveVars';

const useGetSong = (id) => {
  const organisation_ref = useReactiveVar(organisationLoggedInAs)?.id || null;
  const [data, setData] = useState(null);

  const { loading, error } = useQuery(GET_SONG, {
    variables: {
      id,
      organisation_ref,
    },
    onCompleted: (res) => {
      dismissLoadingMessage();
      const modifiedSong = appendTokenToSongAssets({ ...res.song });
      setData({ song: modifiedSong });
    },
    onError: () => {
      dismissLoadingMessage();
      displayErrorMessage('Could not load song');
    },
  });

  return { data, loading, error };
};

export default useGetSong;
